// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"28fc2e8e","84":"bbcc3f04","247":"10965561","440":"ef6b7dcb","453":"f683d231","627":"c07713cb","738":"08b40eb5","834":"f6bcf9a0","923":"45fdf4ab"}[chunkId] + ".chunk.js";
};